import React, { useState} from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import FirmaUnos from './FirmaTabs/FirmaUnos';
import FirmaPregled from './FirmaTabs/FirmaPregled';
import FirmaTekuciRacuni from './FirmaTabs/FirmaTekuciRacuni';
import FirmaAlarmi from './FirmaTabs/FirmaAlarmi';
import FirmaSef from './FirmaTabs/FirmaSef';

const FirmaHome = () => {
  const { t } = useTranslation();

    const [changeView, setChangeView] = useState(2);
    const activeClass = 'activeButton'

    /* SEF podešavanja (API ključ) vide samo direktor i eskaliran — tab se
       ostalima i ne prikazuje. Pravu zaštitu radi backend
       (requireDirektorIliEskaliran + ista provera u proceduri); ovo je samo da
       ostali ne gledaju karticu koja im ionako vraća 403.

       U store-u OBA podatka stoje kao objekti, ne kao gole vrednosti:
       user_role je {roleId}, a eskaliran je {eskaliran} (vidi Login/login.js).
       Poređenje sa golom vrednošću daje NaN, pa se tab ne bi prikazao NIKOME. */
    const userRole  = useSelector((s) => s.user_role);
    const eskaliran = useSelector((s) => s.eskaliran);
    const smeSef = Number(userRole?.roleId) === 1 || !!eskaliran?.eskaliran;

return (
    <div style={{marginTop:'1%'}}>
        <Button id={changeView == 1 && activeClass} label={t('fakture.pregled')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(1)} } />
        <Button id={changeView == 2 && activeClass} label={t('admin.unos')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(2)} } />
        <Button id={changeView == 3 && activeClass} label={t('admin.tekuciRacuni')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(3)} } />
        <Button id={changeView == 4 && activeClass} label={t('firmaAlarm.tab')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(4)} } />
        {smeSef && <Button id={changeView == 5 && activeClass} label={t('sefKonf.tab')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(5)} } />}
        {changeView == 1 &&  <FirmaPregled/>}
        {changeView == 2 && <FirmaUnos/>}
        {changeView == 3 && <FirmaTekuciRacuni/>}
        {changeView == 4 && <FirmaAlarmi/>}
        {changeView == 5 && smeSef && <FirmaSef/>}
    </div>
)
}

export default FirmaHome;